import styled from "styled-components";
import useFirestore from "../common/useFirestore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAccount from "../authorization/useAccount";

function useProduct(id){
    const uid = sessionStorage.getItem("uid");
    const navigate = useNavigate();
    const {getCommonUser} = useAccount(uid);
    const {readFirestoreOneDoc, writeFirestore} = useFirestore();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [modal, setModal] = useState({
        title:"",
        content:"",
        buttonName:"",
        onConfirmClickHandler: () => {},
    })
    const [product, setProduct] = useState({
        title:"",
        thumbnail_img:"",
        class_list:[],
        option_list:[],
        detail_img:""
    })

    const [selectedClass, setSelectedClass] = useState("");
    const [selectedOptionList, setSelectedOptionList] = useState([]);

    useEffect(() => {
        getInstructorProduct();
    }, [id])

    const getInstructorProduct = async() => {
        const product = await readFirestoreOneDoc("Product", id).then(res => {
            if(res.exists()){
                return {...res.data(), id:res.id};
            }
            return null;
        });
        if(product){
            setProduct(product);
        }
        else{
            setModal({
                title:"ERROR",
                content:"해당 강사의 클래스가 아직 개설되지 않았습니다",
                buttonName:"확인",
                onConfirmClickHandler:() => navigate(-1)
            })
            setIsOpenModal(true);
        }
    }

    const onProductItemChangeHandler = (name, id) => {
        if(name === "class"){
            setSelectedClass(id);
        }else if(name === "option"){
            if(selectedOptionList.includes(id)){
                setSelectedOptionList(prev => prev.filter(item => item !== id));
            }else{
                setSelectedOptionList(prev => [...prev, id]);
            }
        }
    }

    const onAddToCartClickHandler = async() => {
        const user = await getCommonUser();
        if(!user){
            setModal({
                title:"ERROR",
                content:"계정에 오류가 있습니다\n 다시 로그인 해주세요",
                buttonName:"확인",
                onConfirmClickHandler:() => navigate("/login")
            })
            setIsOpenModal(true);
            return ;
        }
        if(!(selectedClass && selectedOptionList.length)){
            setModal({
                title:"ERROR",
                content:"클래스와 옵션을 둘다 선택해야합니다",
                buttonName:"확인",
                onConfirmClickHandler:() => setIsOpenModal(false)
            })
            setIsOpenModal(true);
            return;
        }
        const data = {
            class:selectedClass,
            option_list:selectedOptionList
        }
        const result = await writeFirestore(`Cart/${user.id}/Item`, id, data).then(res => {
            return res;
        })
        if(result){
            setModal({
                title:"SUCCESS",
                content:"장바구니에 등록 되었습니다",
                buttonName:"장바구니로 이동",
                onConfirmClickHandler:() => navigate("/cart")
            })
            setIsOpenModal(true);
        }
    }

    return {product, isOpenModal, modal, selectedClass, selectedOptionList, onProductItemChangeHandler, onAddToCartClickHandler};
}


export default useProduct;